<template>
  <div>
    <Title :pages="[{ icon: 'industry', page: page_title.toUpperCase() }]"></Title>

    <v-container fluid>
      <Modal
        v-if="create_access"
        :button_name="$t('Crear') + ' ' + modal_title"
        :modal_title="modal_title"
        :formBtn="formBtn"
        :dialog="dialog"
        :parent="parent"
        :service="service"
        @updateDialog="updateDialog"
        @loadList="loadList(service)"
        :item="mainItem"
        @updateItem="
          (newItem) => {
            mainItem = newItem;
          }
        "
      />

      <DialogYesNo :open="dialog_change_status" :title="title_change_status" :message="message_change_status" @cancel="dialog_change_status = false" @accept="changeToInExecution" :loading="loading_change_status" />

      <DialogYesNo :open="dialog_cancel" :title="title_cancel" :message="message_cancel" @cancel="dialog_cancel = false" @accept="cancelOrders" :loading="loading_cancel" />

      <ModalChangeInternalState 
        :dialog="dialog_change_internal_state" 
        :productionOrder="selected_order_for_state"
        @updateDialog="updateDialogChangeInternalState"
        @updated="onInternalStateUpdated"
      />

      <ModalFinishedOrder 
        :dialog="dialog_finish_order" 
        :productionOrder="selected_order_for_finish"
        :view_finish_order="view_finish_order"
        @updateDialog="updateDialogFinishOrder"
        @updated="onOrderFinished"
      />

      <ModalStatusHistory 
        :dialog="dialog_status_history" 
        :productionOrder="selected_order_for_history"
        @updateDialog="updateDialogStatusHistory"
      />

      <ModalInternalStateHistory 
        :dialog="dialog_internal_state_history" 
        :productionOrder="selected_order_for_internal_history"
        @updateDialog="updateDialogInternalStateHistory"
      />

      <ModalPrintLabel 
        :dialog="dialog_print_label" 
        :productionOrder="selected_order_for_print"
        @updateDialog="updateDialogPrintLabel"
        @print="onPrintLabel"
      />

      <v-card>
        <div class="row mb-2 mt-0">
          <div class="col-md-12" v-if="list_access">
            <div class="col-md-12" style="background:white; elevation-0">
              <div class="row pt-5">
                <div class="col-md-3 pt-0">
                  <v-menu
                    ref="desde_selected"
                    v-model="desde_selected_open"
                    :close-on-content-click="false"
                    :close-on-click="false"
                    :return-value.sync="desde_selected"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="auto"
                    clearable
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="desde_selected"
                        label="Desde"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        class="pt-0 mt-0"
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="desde_selected" type="date" no-title scrollable>
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="desde_selected_open = false"> Cancel </v-btn>
                      <v-btn text color="primary" @click="$refs.desde_selected.save(desde_selected)"> OK </v-btn>
                    </v-date-picker>
                  </v-menu>
                </div>

                <div class="col-md-3 pt-0">
                  <v-menu
                    ref="hasta_selected"
                    v-model="hasta_selected_open"
                    :close-on-content-click="false"
                    :close-on-click="false"
                    :return-value.sync="hasta_selected"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="auto"
                    clearable
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="hasta_selected"
                        label="Hasta"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        class="pt-0 mt-0"
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="hasta_selected" type="date" no-title scrollable>
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="hasta_selected = false"> Cancel </v-btn>
                      <v-btn text color="primary" @click="$refs.hasta_selected.save(hasta_selected)"> OK </v-btn>
                    </v-date-picker>
                  </v-menu>
                </div>

                <div class="col-md-3 pt-0">
                  <v-combobox
                    v-model="formula_selected"
                    data-vv-as="Fórmula"
                    name="formula_selected"
                    :items="formulas"
                    item-text="name"
                    item-value="id"
                    label="Fórmula"
                    class="pt-0 mt-0"
                    clearable
                  ></v-combobox>
                </div>

                <div class="col-md-3 pt-0">
                  <v-combobox
                    v-model="status_selected"
                    data-vv-as="Estado"
                    name="status_selected"
                    :items="statuses"
                    item-text="name"
                    item-value="id"
                    label="Estado"
                    class="pt-0 mt-0"
                    clearable
                  ></v-combobox>
                </div>
                <div class="col-md-3 pt-0">
                  <v-combobox
                    v-model="internal_state_selected"
                    data-vv-as="Estado"
                    name="internal_state_selected"
                    :items="statuses_internal"
                    item-text="name"
                    item-value="id"
                    label="Estado Interno"
                    class="pt-0 mt-0"
                    clearable
                  ></v-combobox>
                </div>
                <div class="col-md-3 pt-0">
                  <v-combobox
                    v-model="line_production_selected"
                    data-vv-as="Linea de produccion"
                    name="line_production_selected"
                    :items="lines_production"
                    item-text="name"
                    item-value="id"
                    label="Linea de producción"
                    class="pt-0 mt-0"
                    clearable
                  ></v-combobox>
                </div>
                  <div class="col-md-3 pt-0">
                  <v-combobox
                    v-model="user_assignated_selected"
                    data-vv-as="Usuario asignado"
                    name="user_assignated_selected"
                    :items="users_assignated"
                    item-text="business_name"
                    item-value="id"
                    label="Usuario Asignado"
                    class="pt-0 mt-0"
                    clearable
                  ></v-combobox>
                </div>
                <div class="col-md-3 pt-0 text-end">
                  <v-btn color="info" class="" @click="filter">Buscar</v-btn>
                </div>
              </div>
            </div>
          </div>
        </div>
      </v-card>

      <v-card v-if="list_access">
        <v-card-title>
          <span class="text-uppercase">{{ page_title }}</span>
          <v-btn 
            :color="allExpanded ? 'blue-grey' : 'blue-grey'" 
            outlined
            small
            @click="toggleExpandAll" 
            class="ml-3"
          >
            <v-icon small left>
              {{ allExpanded ? "mdi-chevron-up" : "mdi-chevron-down" }}
            </v-icon>
            {{ allExpanded ? "Contraer Todo" : "Expandir Todo" }}
          </v-btn>
          <v-spacer></v-spacer>
          <v-text-field v-model="search" append-icon="search" label="Buscar" single-line hide-details></v-text-field>
        </v-card-title>

        <div class="mb-4" v-show="selected.length != 0 && update_access">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                style="border: 1px solid; border-radius: 100px; padding: 3px"
                color="blue-grey"
                :class="isActiveBlinking ? 'ml-3 button_blinking' : 'ml-3'"
                @click="toggleClass"
                v-bind="attrs"
                v-on="on"
              >
                more_vert
              </v-icon>
            </template>
            <v-list>
              <v-list-item dense @click="dialogChangeStatus()">
                <v-list-item-title> Pasar a Ejecución</v-list-item-title>
              </v-list-item>
              <v-list-item dense @click="dialogCancel()">
                <v-list-item-title> Cancelar Órdenes</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>

        <v-data-table
          v-model="selected"
          :headers="headers"
          :items="list"
          :search="search"
          :loading="loading"
          loading-text="Cargando..."
          :options="{
            descending: true,
            itemsPerPage: 15,
          }"
          @pagination="updatePagination"
          :footer-props="{
            itemsPerPageOptions: [5, 10, 15, 50, -1],
          }"
        >
          <template v-slot:item="{ item, isSelected, select, index }">
            <tr>
              <td class="pr-0">
                <v-btn 
                  icon
                  small
                  @click="toggleExpand(index)"
                  
                >
                  <v-icon small>
                    {{ isExpanded(index) ? "mdi-chevron-down" : "mdi-chevron-right" }}
                  </v-icon>
                </v-btn>
              </td>
              <td class="pl-0">
                <v-checkbox 
                  v-if="item.status && item.status.id !== ProductionOrderStates.STATE_CANCELLED && item.status.id !== ProductionOrderStates.STATE_FINISHED"
                  :input-value="isSelected" 
                  style="margin: 0px; padding: 0px" 
                  hide-details 
                  @change="select($event)" 
                />
              </td>
              <td>{{ item.scheduled_date }}</td>
              <td>
                <div v-if="item.status && item.status.id === ProductionOrderStates.STATE_FINISHED && item.end_date">
                  {{ item.end_date }}
                </div>
                <div v-else>
                  <div :class="isOverdue(item.estimated_end_date) ? 'red--text font-weight-bold' : ''">
                    {{ item.estimated_end_date }}
                  </div>
                  <div v-if="isOverdue(item.estimated_end_date)" class="text-caption red--text">
                    {{ getDaysOverdue(item.estimated_end_date) }} días de atraso
                  </div>
                </div>
              </td>
              <td>
                <div class="d-flex align-center">

                  <span><div class="text-caption grey--text">Origen:</div> {{ item.warehouse_origen ? item.warehouse_origen.name : '-' }}</span> <v-divider vertical class="mr-2 ml-2" ></v-divider>
                  <span><div class="text-caption grey--text">Destino:</div> {{ item.warehouse_destino ? item.warehouse_destino.name : '-' }}</span>
                </div>
              </td>
              <td>{{ item.user_assignated ? item.user_assignated.business_name : '-' }}</td>
              <td>
                <div v-if="item.formula">
                  <div class="font-weight-medium">{{ item.formula.name }}</div>
                  <div class="text-caption grey--text">Cantidad: {{ item.quantity }}</div>
                </div>
                <div v-else>-</div>
              </td>
              <td>{{ item.external_reference || '-' }}</td>
              <td>{{ item.line_production != null ? item.line_production.name : "-" }}</td>
              <td> <div class="status-badge font-weight-medium">{{ item.internal_state ? item.internal_state.name : '-' }}</div></td>
              <td>
                <div class="status-badge font-weight-medium" :class="'status-' + (item.status.id || item.status)">
                  {{ item.status.name }}
                </div>
              </td>
              <td class="text-center px-0">
                <v-tooltip bottom v-if="item.status && item.status.id !== ProductionOrderStates.STATE_CANCELLED && item.status.id !== ProductionOrderStates.STATE_FINISHED">
                  <template v-slot:activator="{ on }">
                    <v-icon v-if="update_access" v-on="on" small color="blue" class="mr-2" @click="editItem(item)"> edit </v-icon>
                  </template>
                  <span>Editar</span>
                </v-tooltip>

                <v-tooltip bottom v-if="item.status && item.status.id !== ProductionOrderStates.STATE_CANCELLED">
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on" small color="blue" class="mr-2" @click="viewItem(item)"> remove_red_eye </v-icon>
                  </template>
                  <span>Ver</span>
                </v-tooltip>

                <v-menu offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon small color="grey darken-2" v-bind="attrs" v-on="on"> more_vert </v-icon>
                  </template>

                  <v-list dense>
                    <v-list-item dense @click="printItem(item)">
                      <v-list-item-icon class="mr-1">
                        <v-icon small color="purple">print</v-icon>
                      </v-list-item-icon>
                      <v-list-item-title>Descargar PDF</v-list-item-title>
                    </v-list-item>

                    <v-list-item dense @click="printItem(item, true)">
                      <v-list-item-icon  class="mr-1">
                        <v-icon small color="purple">print</v-icon>
                      </v-list-item-icon>
                      <v-list-item-title>Ver PDF</v-list-item-title>
                    </v-list-item>

                    <v-list-item dense @click="openPrintLabel(item)">
                      <v-list-item-icon  class="mr-1">
                        <v-icon small color="purple">label</v-icon>
                      </v-list-item-icon>
                      <v-list-item-title>Imprimir Etiqueta</v-list-item-title>
                    </v-list-item>

                    <v-divider></v-divider>

                    <v-list-item dense @click="openStatusHistory(item)">
                      <v-list-item-icon  class="mr-1">
                        <v-icon small color="blue">history</v-icon>
                      </v-list-item-icon>
                      <v-list-item-title>Ver Historial de Estados</v-list-item-title>
                    </v-list-item>

                    <v-list-item dense @click="openInternalStateHistory(item)">
                      <v-list-item-icon  class="mr-1">
                        <v-icon small color="blue">history</v-icon>
                      </v-list-item-icon>
                      <v-list-item-title>Ver Historial Estados Internos</v-list-item-title>
                    </v-list-item>


                    <v-list-item v-if="update_access && item.status && item.status.id === ProductionOrderStates.STATE_PENDING" dense @click="passToInExecution(item)">
                      <v-list-item-icon  class="mr-1">
                        <v-icon small color="green">refresh</v-icon>
                      </v-list-item-icon>
                      <v-list-item-title>Pasar a Ejecución</v-list-item-title>
                    </v-list-item>


                    <v-list-item v-if="update_access && item.status &&( item.status.id !== ProductionOrderStates.STATE_CANCELLED && item.status.id !== ProductionOrderStates.STATE_FINISHED)" dense @click="openChangeInternalState(item)">
                      <v-list-item-icon  class="mr-1">
                        <v-icon small color="orange">swap_horiz</v-icon>
                      </v-list-item-icon>
                      <v-list-item-title>Cambiar Estado Interno</v-list-item-title>
                    </v-list-item>


                    <v-list-item v-if="update_access && item.status && item.status.id === ProductionOrderStates.STATE_IN_EXECUTION" dense @click="finishOrder(item)">
                      <v-list-item-icon  class="mr-1">
                        <v-icon small color="success">check_circle</v-icon>
                      </v-list-item-icon>
                      <v-list-item-title>Finalizar Orden</v-list-item-title>
                    </v-list-item>

                    <v-list-item v-if="update_access && item.status && (item.status.id === ProductionOrderStates.STATE_PENDING || item.status.id === ProductionOrderStates.STATE_IN_EXECUTION)" dense @click="cancelOrder(item)">
                      <v-list-item-icon  class="mr-1">
                        <v-icon small color="red">cancel</v-icon>
                      </v-list-item-icon>
                      <v-list-item-title>Cancelar Orden</v-list-item-title>
                    </v-list-item>


                    <v-list-item v-if="delete_access && item.status && item.status.id === ProductionOrderStates.STATE_PENDING" dense @click="deleteItem(item)">
                      <v-list-item-icon  class="mr-1">
                        <v-icon small color="red">delete</v-icon>
                      </v-list-item-icon>
                      <v-list-item-title>Eliminar</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </td>
            </tr>
            
            <!-- Fila expandida con observaciones -->
            <tr v-if="isExpanded(index)" :key="`expanded-${index}`">
              <td :colspan="headers.length" class="pa-0">
                <div class="pa-4" style="background-color: #f5f5f5;">
                  <div class="d-flex align-start">
                    <div>
                      <div class="mb-1 font-weight-bold">Observaciones</div>
                      <div class="body-2">{{ item.observations || 'Sin observaciones' }}</div>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </template>

          <template v-slot:no-results>
            <v-alert :value="true" color="error" icon="warning">
              {{ "Busqueda sin resultados - " + search }}
            </v-alert>
          </template>
        </v-data-table>
      </v-card>

      <DialogDelete :dialog_delete="dialog_delete" @updateDialogDelete="updateDialogDelete" @deleteItemConfirm="deleteItemConfirm" />
    </v-container>
  </div>
</template>

<script>
import Constant from "@/constants/sections";
import { generalService } from "@/libs/ws/generalService";
import { formulaService } from "@/libs/ws/formulaService";
import { formatUtils } from "@/libs/utils/formatUtils";
import GenericMixin from "@/mixins/GenericMixin.vue";
import Title from "@/components/Title.vue";
import DialogDelete from "@/components/DialogDelete.vue";
import DialogYesNo from "@/components/DialogYesNo.vue";
import Modal from "./Modal.vue";
import ModalChangeInternalState from "./ModalChangeInternalState.vue";
import ModalFinishedOrder from "./ModalFinishedOrder.vue";
import ModalStatusHistory from "./ModalStatusHistory.vue";
import ModalInternalStateHistory from "./ModalInternalStateHistory.vue";
import ModalPrintLabel from "./ModalPrintLabel.vue";
import RolMixin from "@/mixins/RolMixin.vue";
import { productionOrderService } from "../../../libs/ws/productionOrderService";
import ProductionOrderStates from "@/constants/productionStates";
import { employeesService } from "../../../libs/ws/employeesService";

export default {
  components: { Title, Modal, ModalChangeInternalState, ModalFinishedOrder, ModalStatusHistory, ModalInternalStateHistory, ModalPrintLabel, DialogDelete, DialogYesNo },
  mixins: [GenericMixin, RolMixin],
  data() {
    return {
      ProductionOrderStates: ProductionOrderStates,
      formatUtils: formatUtils,
      parent: this,
      service: productionOrderService,
      page_title: "Ordenes de Produccion",
      modal_title: "Orden de Produccion",
      mainItem: {
        id: "",
        creation_date: new Date().toISOString().substr(0, 10),
        scheduled_date: new Date().toISOString().substr(0, 10),
        estimated_end_date: new Date().toISOString().substr(0, 10),
        quantity: null,
        quantity_product_final: null,
        origen_referencia: "",
        external_reference: "",
        observations: "",
        line_production: null,
        warehouse_origen: null,
        warehouse_destino: null,
        user_created: null,
        user_assignated: null,
        formula: null,
        internal_state: null,
      },
      defaultItem: null,
      headers: [
        { text: "", align: "center", sortable: false, value: "", width: "48px" },
        { text: "", align: "center", sortable: false, value: "" },
        { text: "Fecha Programada", value: "scheduled_date", align: "left", sortable: true },
        { text: "Fecha Finalización", value: "", align: "left", sortable: true },
        { text: "Almacenes", align: "left", sortable: false },
        { text: "Usuario Asignado", value: "user_assignated.business_name", align: "left" },
        { text: "Fórmula / Cantidad", value: "formula.name", align: "left" },
        { text: "Referencia Externa", value: "external_reference", align: "left" },
        { text: "Linea de producción", value: "line_production.name", align: "center" },
        { text: "Estado interno", value: "internal_state.name", align: "center" },
        { text: "Estado", value: "status.name", align: "center" },
        { text: "Accion", align: "center", sortable: false },
      ],
      list: [],
      dialog_delete: false,
      selected: [],
      isActiveBlinking: true,
      dialog_change_status: false,
      title_change_status: "",
      message_change_status: "",
      loading_change_status: false,
      dialog_cancel: false,
      title_cancel: "",
      message_cancel: "",
      loading_cancel: false,
      statuses: [],
      statuses_internal: [],
      lines_production: [],
      users_assignated: [],
      formulas: [],
      dialog_change_internal_state: false,
      selected_order_for_state: null,
      dialog_finish_order: false,
      selected_order_for_finish: null,
      dialog_status_history: false,
      selected_order_for_history: null,
      dialog_internal_state_history: false,
      selected_order_for_internal_history: null,
      dialog_print_label: false,
      selected_order_for_print: null,
      desde_selected_open: false,
      hasta_selected_open: false,
      desde_selected: new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString().slice(0, 10),
      hasta_selected: new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0).toISOString().slice(0, 10),
      formula_selected: null,
      status_selected: null,
      line_production_selected: null,
      internal_state_selected: null,
      user_assignated_selected: null,
      view_finish_order: false,
      expandedItems: [],
    };
  },
  computed: {
    allExpanded() {
      return this.list.length > 0 && this.expandedItems.length === this.list.length;
    }
  },
  mounted() {
    this.defaultItem = JSON.parse(JSON.stringify(this.mainItem));
    this.loadFormulas();
    this.loadStatuses();
    this.loadStatusesInternal();
    this.loadLinesProduction();
    this.loadEmployees();
    this.loadList(this.service, this.getFilterParams());
  },
  methods: {
    loadEmployees(){
      employeesService
        .filter()
        .then((response) => {
          this.users_assignated = response.result;
        })
        .catch((e) => {
          console.log("employees.filter error", e);
        });
    },  
    toggleClass() {
      this.isActiveBlinking = false;
    },
    toggleExpand(index) {
      const i = this.expandedItems.indexOf(index);
      if (i > -1) {
        this.expandedItems.splice(i, 1);
      } else {
        this.expandedItems.push(index);
      }
    },
    isExpanded(index) {
      return this.expandedItems.includes(index);
    },
    toggleExpandAll() {
      if (this.allExpanded) {
        this.expandedItems = [];
      } else {
        this.expandedItems = [...Array(this.list.length).keys()];
      }
    },
    dialogChangeStatus() {
      this.dialog_change_status = true;
      this.title_change_status = "Pasar a Ejecución";
      this.message_change_status = `¿Está seguro de pasar ${this.selected.length > 1 ? 'estas ' + this.selected.length + ' órdenes' : 'esta orden'} a estado En Ejecución?`;
    },
    changeToInExecution() {
      this.loading_change_status = true;
      const ids = this.selected.map(item => item.id);
      
      this.service
        .changeToInExecution({ ids: ids })
        .then((response) => {
          if (response.status === true) {
            this.$toast.success(response.msg, "OK");
            this.selected = [];
            this.dialog_change_status = false;
            this.loadList(this.service, this.getFilterParams());
          } else {
            this.$toast.error(response.msg, "Error");
          }
        })
        .catch((e) => {
          console.log("service.changeToInExecution error", e);
          this.$toast.error("Error al cambiar estado", "Error");
        })
        .finally(() => {
          this.loading_change_status = false;
        });
    },
    passToInExecution(item) {
      this.selected = [item];
      this.dialog_change_status = true;
      this.title_change_status = "Pasar a Ejecución";
      this.message_change_status = "¿Está seguro de pasar esta orden a estado En Ejecución?";
    },
    dialogCancel() {
      this.dialog_cancel = true;
      this.title_cancel = "Cancelar Órdenes";
      this.message_cancel = `¿Está seguro de cancelar ${this.selected.length > 1 ? 'estas ' + this.selected.length + ' órdenes' : 'esta orden'}?`;
    },
    cancelOrders() {
      this.loading_cancel = true;
      const ids = this.selected.map(item => item.id);
      
      this.service
        .cancelOrders({ ids: ids })
        .then((response) => {
          if (response.status === true) {
            this.$toast.success(response.msg, "OK");
            this.selected = [];
            this.dialog_cancel = false;
            this.loadList(this.service, this.getFilterParams());
          } else {
            this.$toast.error(response.msg, "Error");
          }
        })
        .catch((e) => {
          console.log("service.cancelOrders error", e);
          this.$toast.error("Error al cancelar órdenes", "Error");
        })
        .finally(() => {
          this.loading_cancel = false;
        });
    },
    cancelOrder(item) {
      this.selected = [item];
      this.dialog_cancel = true;
      this.title_cancel = "Cancelar Orden";
      this.message_cancel = "¿Está seguro de cancelar esta orden?";
    },
    isOverdue(estimatedDate) {
      if (!estimatedDate) return false;
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const estimated = new Date(estimatedDate);
      estimated.setHours(0, 0, 0, 0);
      return estimated < today;
    },
    getDaysOverdue(estimatedDate) {
      if (!estimatedDate) return 0;
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const estimated = new Date(estimatedDate);
      estimated.setHours(0, 0, 0, 0);
      const diffTime = today - estimated;
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      return diffDays;
    },
    openChangeInternalState(item) {
      this.selected_order_for_state = item;
      this.dialog_change_internal_state = true;
    },
    updateDialogChangeInternalState(value) {
      this.dialog_change_internal_state = value;
      if (!value) {
        this.selected_order_for_state = null;
      }
    },
    onInternalStateUpdated() {
      this.loadList(this.service, this.getFilterParams());
    },
    finishOrder(item) {
      this.selected_order_for_finish = item;
      this.dialog_finish_order = true;
    },
    updateDialogFinishOrder(value) {
      this.dialog_finish_order = value;
      if (!value) {
        this.selected_order_for_finish = null;
        this.view_finish_order = false;
      }
    },
    onOrderFinished() {
      this.loadList(this.service, this.getFilterParams());
    },
    openStatusHistory(item) {
      this.selected_order_for_history = item;
      this.dialog_status_history = true;
    },
    updateDialogStatusHistory(value) {
      this.dialog_status_history = value;
      if (!value) {
        this.selected_order_for_history = null;
      }
    },
    openInternalStateHistory(item) {
      this.selected_order_for_internal_history = item;
      this.dialog_internal_state_history = true;
    },
    updateDialogInternalStateHistory(value) {
      this.dialog_internal_state_history = value;
      if (!value) {
        this.selected_order_for_internal_history = null;
      }
    },
    openPrintLabel(item) {
      this.selected_order_for_print = item;
      this.dialog_print_label = true;
    },
    updateDialogPrintLabel(value) {
      this.dialog_print_label = value;
      if (!value) {
        this.selected_order_for_print = null;
      }
    },
    onPrintLabel(data) {
      this.loading = true;
      this.service
        .printLabel(data)
        .then((response) => {
          let nombre = "etiqueta_orden_" + data.production_order_id;
          if (!generalService.downloadPdf(response, nombre + ".pdf", true)) {
            this.$toast.error("Error al generar la etiqueta", "Error");
          }
        })
        .catch((error) => {
          console.log(error);
          console.log(error.response);
          this.$toast.error("Error al generar la etiqueta", "Error");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    loadStatuses() {
      this.service
        .list_status()
        .then((response) => {
          this.statuses = response.result;
        })
        .catch((e) => {
          console.log("statuses.list error", e);
        });
    },
    loadStatusesInternal() {
      this.service
        .list_status_internal()
        .then((response) => {
          this.statuses_internal = response.result;
        })
        .catch((e) => {
          console.log("statuses_internal.list error", e);
        });
    },
    loadLinesProduction() {
      generalService.setSection(Constant.SECTION_PRODUCTION_LINES);
      generalService
        .filter()
        .then((response) => {
          this.lines_production = response.result;
        })
        .catch((e) => {
          console.log("lines_production.filter error", e);
        });

    },
    loadFormulas() {
      formulaService
        .filter()
        .then((response) => {
          this.formulas = response.result;
        })
        .catch((e) => {
          console.log("formulas.filter error", e);
        });
    },
    getFilterParams() {
      const param = {
        date_from: this.desde_selected != null ? this.desde_selected : null,
        date_to: this.hasta_selected != null ? this.hasta_selected : null,
        formula: this.formula_selected != null ? this.formula_selected.id : null,
        status: this.status_selected != null ? this.status_selected.id : null,
        internal_state: this.internal_state_selected != null ? this.internal_state_selected.id : null,
        line_production: this.line_production_selected != null ? this.line_production_selected.id : null,
        user_assignated: this.user_assignated_selected != null ? this.user_assignated_selected.id : null,
      };
      return param;
    },
    filter() {
      this.loadList(this.service, this.getFilterParams());
    },
    loadList(service, param = null) {
      this.loading = true;

      if (param == null) {
        param = this.getFilterParams();
      }

      service
        .filter(param)
        .then((response) => {
          this.list = response.result;
          this.selected = [];
          this.loading = false;
        })
        .catch((e) => {
          console.log("service.filter error");
          console.log(e);
          this.loading = false;
        });
    },
    deleteItemConfirm() {
      this.delete(this.service);
      this.dialog_delete = false;
      this.loadList(this.service, this.getFilterParams());
    },
    printItem(item, open = false) {
      this.loading = true;
      this.service
        .print(item.id)
        .then((response) => {
          let nombre = "orden_" + item.id;
          if (!generalService.downloadPdf(response, nombre + ".pdf", open)) {
            this.$toast.error("Error al generar el PDF", "Error");
          }
        })
        .catch((error) => {
          console.log(error);
          console.log(error.response);
          this.$toast.error("Error al generar el PDF", "Error");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getStatusColor(status) {
      if (!status) return "grey";
      
      switch (status.id) {
        case ProductionOrderStates.STATE_PENDING:
          return "orange";
        case ProductionOrderStates.STATE_IN_EXECUTION:
          return "blue";
        case ProductionOrderStates.STATE_FINISHED:
          return "green";
        case ProductionOrderStates.STATE_CANCELLED:
          return "red";
        default:
          return "grey";
      }
    },
    viewItem(item) {
      // Si la orden está finalizada, abrir el modal de finalización en modo vista
      if (item.status && item.status.id === ProductionOrderStates.STATE_FINISHED) {
        this.selected_order_for_finish = item;
        this.dialog_finish_order = true;
        this.view_finish_order = true;
      } else {
        // Para otros estados, usar el comportamiento por defecto del mixin
        this.viewdIndex = this.list.indexOf(item);
        this.mainItem = JSON.parse(JSON.stringify(item));
        this.dialog = true;
      }
    },
  },
};

// TODO agregar un boton de limpiar busqueda.
</script>
